// extracted by mini-css-extract-plugin
export default {"centered":"HomePage-styles-module--centered--itTAE"};